export default __webpack_public_path__ + "static/tag-dont-2-light-c1681f7525f5fd3474bb0b3aa49dcca07aa8423bc8188aba34d82e6511747d02.png";